import { themeQuartz } from "ag-grid-enterprise";

 export const gridTheme = themeQuartz.withParams({
    headerBackgroundColor: "#000",
    headerColumnBorder: {
      width: 1,
      style: "solid",
      color: "grey",
    },
    headerTextColor: "#fff",
  });